import { $api } from '@shared/api';

export const getCountryList = () => {
    // @ts-ignore
    const getCountryListUrl = routable.getRoute('getCountryList');
    return $api(getCountryListUrl);
};
